<template>
  <modal-form :class="$style.dialog" @cancel="$formCancelHandler" @submit="$formSubmitHandler">
    <span slot="header">Configure {{ template.name }} Table</span>

    <div slot="body" class="vModalDefaultBody">
      <template v-for="action in template.actions">
        <rb-input v-if="action.type === 'filter'" :key="'f' + action.id">
          <span slot="label">{{ action.label }}</span>
          <rb-select v-model="filters[action.id]" class="simple">
            <rb-option
              v-for="option in action.options"
              :key="option.label"
              :value="option.filter"
            >
              {{ option.label }}
            </rb-option>
          </rb-select>
        </rb-input>

        <rb-input v-else-if="action.type === 'toggle'" :key="'t' + action.id" :error="$showError(action.id)">
          <span slot="label">{{ action.label }}</span>
          <rb-checkboxes
            v-model="filters[action.id]"
            v-validate="'required'"
            :field="fields[action.id]"
            :name="action.id"
            :data-vv-as="action.label"
          >
            <rb-checkbox v-for="option in action.options" :key="option.id" :value="option.id">
              {{ option.label }}
            </rb-checkbox>
          </rb-checkboxes>
        </rb-input>
      </template>
    </div>
  </modal-form>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import ModalForm from '../../_core/RbModalForm.vue'
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbSelect from '../../_core/RbSelect.vue'
  import RbCheckboxes from '../../_core/RbCheckboxes.vue'
  import RbFormMixin from 'root/v-components/_mixins/RbFormMixin.vue'
  import RbInput from 'root/v-components/_core/RbInput.vue'

  export default {
    name: 'RbQuestionnaireEditConfigureTableDialog',

    components: {
      RbInput,
      ModalForm,
      RbSelect,
      RbCheckboxes
    },

    mixins: [ RbFormMixin, DialogMixin ],

    props: [ 'template', 'config' ],

    data () {
      return {
        filters: {}
      }
    },

    created () { this.initLocalConfig( this.config ) },

    methods: {
      onSubmit () { return { id: this.template.id, data: this.filters } },

      initLocalConfig ( config ) { this.filters = cloneDeep( config.data ) }
    },

    watchers: { config ( val ) { this.initLocalConfig(val) } }
  }
</script>

<style lang="stylus" module>
  .dialog {
    min-width: 400px
  }
</style>
